import useGoBack from 'utilities/navigation/back'
import BackIcon from 'assets/images/rectangle/east.svg'
import classNames from 'classnames'
import { useLocation } from 'react-router-dom'
interface IHeaderProps {
    title: string
    isGreen?: boolean
}
export default function Header({ title, isGreen = false }: IHeaderProps) {
    const goBack = useGoBack()
    const { pathname } = useLocation()
    const isCallback = pathname.includes('gateway-callback/')
    return (
        <div
            className={classNames(
                ' w-full px-2 py-3 flex sticky top-0 z-10  items-center',
                !isCallback ? 'justify-between' : 'justify-center'
            )}
        >
            {!isCallback && (
                <button
                    type="button"
                    onClick={goBack}
                    aria-label="بازگشت"
                    className={classNames(
                        ' -m-2.5 p-2.5 active:scale-90',
                        isGreen ? 'text-green-1' : 'text-black'
                    )}
                >
                    <img src={BackIcon} alt="" />
                </button>
            )}
            <p className={classNames(isGreen ? 'text-green-1' : 'text-black')}>
                {title}
            </p>
            <div></div>
        </div>
    )
}
